import { createSelector } from "reselect";
import { getActiveGroupData } from "./getActiveGroup";
import { PermissionSet } from "common/permissions/types/PermissionSet";

export const getGroupPermissions = createSelector(
    getActiveGroupData,
    (group) => new PermissionSet(group?.authInfo.permissions ?? [])
);
